import '../styles/pages/cancel.css'

function Cancel() {
  return (
    <div className="cancel-page">
      <div className="cancel-content">
        <div className="cancel-icon">❌</div>
        <h2>Betaling annulleret</h2>
        <p>Du annullerede betalingen. Du kan fortsætte med gratis moduler eller prøve igen senere.</p>
        <button className="btn" onClick={() => {
          window.location.href = '/'
        }}>
          Tilbage til appen
        </button>
      </div>
    </div>
  )
}

export default Cancel
